
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent {
  @Input() public buscador: boolean = false;
  mobileOpen = false;
  mobileServicesOpen = false;
  mobileClientOpen = false;
  clientLinks = [
    {
      label: 'Portal de Pagos',
      desc: 'Acceso directo al sistema de clientes.',
      href: 'https://pmm.com.mx/login'
    },
    {
      label: 'Prepago',
      desc: 'Compra tus guías prepagadas.',
      href: 'https://pmm.com.mx/prepago/'
    },
    {
      label: 'PMM en tu Empresa',
      desc: 'Soluciones B2B para tu negocio.',
      href: 'http://www.pmmentuempresa.com/'
    }
  ];

  constructor(public router: Router) {}

  toggleMobile() {
    this.mobileOpen = !this.mobileOpen;
    if (!this.mobileOpen) {
      this.mobileServicesOpen = false;
      this.mobileClientOpen = false;
    }
  }

  toggleMobileServices() {
    this.mobileServicesOpen = !this.mobileServicesOpen;
  }

  toggleMobileClient() {
    this.mobileClientOpen = !this.mobileClientOpen;
  }

  closeMobile() {
    this.mobileOpen = false;
    this.mobileServicesOpen = false;
    this.mobileClientOpen = false;
  }
}
